TrelloModel = require 'models/internal/trello-model'
_ = require 'underscore'

module.exports = class Label extends TrelloModel

  typeName: 'Label'
  urlRoot: '/1/labels'

  getBoard: ->
    @modelCache.get('Board', @get('idBoard'))

  editable: ->
    @getBoard().editable()

  colorSortVal: ->
    v = _.indexOf(Label.colors, @get('color'))
    if v >= 0 then v else Infinity

  nameSortVal: ->
    (@get('name') ? '').toLowerCase()

  @compare: (a, b) ->
    cs = a.colorSortVal() - b.colorSortVal()
    if cs != 0 && !isNaN(cs)
      return cs
    a.nameSortVal().localeCompare(b.nameSortVal())

  @colors: ['green', 'yellow', 'orange', 'red', 'purple',
            'blue', 'sky', 'lime', 'pink', 'black']



// WEBPACK FOOTER //
// ./app/scripts/models/label.coffee